export default __webpack_public_path__ + "static/media/home-icon-active.4c4160f9.webp";